export default __webpack_public_path__ + "static/media/handprint-4-5-page.0b3d186b.png";